import { useTranslation } from 'react-i18next';
import { Play, Square } from 'lucide-react';

import { Button } from '@/components/ui/button';
import { ActivityDialog } from '@/features/activities/components/ActivityDialog';
import type { Task } from '../types';

interface ActivityActionButtonProps {
  task: Task;
  activityId?: number;
  onSuccess?: () => void;
  isStop?: boolean;
}

export function ActivityActionButton({ task, activityId, onSuccess, isStop }: ActivityActionButtonProps) {
  const { t } = useTranslation();

  const trigger = (
    <Button
      variant="outline"
      size="sm"
      className={
        isStop
          ? 'border-blue-500 text-blue-500 hover:bg-blue-50'
          : 'border-blue-500 text-blue-500 hover:bg-blue-50'
      }
    >
      {isStop ? <Square className="h-4 w-4" /> : <Play className="h-4 w-4" />}
      {isStop ? t('stop') : t('start')}
    </Button>
  );

  return (
    <ActivityDialog
      activityId={activityId}
      taskId={task.id}
      showTaskSelector={false}
      onSuccess={onSuccess}
      trigger={trigger}
    />
  );
}
